module.exports = __webpack_public_path__ + "static/media/stripe.c532db84.png";